const BASE_URL =
  process.env.NODE_ENV == 'development'
    ? 'http://localhost:8000/api/v1'
    : //   "https://my.followjet.com:2053/api/v1"
      `${window.location.origin}/api/api/v1`;

export { BASE_URL };
// 6Ld5XrIfAAAAAKLEH_FoIefFlAFomb7dotdgKB6_
